// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__19hZM","actionsCol":"EnrolledClinics_actionsCol__3Uw0v"};